import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { applyInitialTheme } from "./lib/theme";
import { applyInitialDensity } from "./lib/density";
import "./styles/globals.css";

applyInitialTheme();
applyInitialDensity();

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
